import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import SidebarItem from "../Items/SidebarItem";

interface CollapseButtonProps {
  expanded: boolean;
  onClick: () => void;
}

const CollapseButton = ({ expanded, onClick }: CollapseButtonProps) => {
  return (
    <SidebarItem
      icon={expanded ? <KeyboardArrowLeftIcon /> : <KeyboardArrowRightIcon />}
      label="COLLAPSE"
      expanded={expanded}
      onClick={onClick}
      tooltip={expanded ? "Collapse Menu" : "Expand Menu"}
    />
  );
};

export default CollapseButton;
